import { failString, Failure } from "query/Fetch";

export enum LoadingState {
    Loading,
    Loaded,
    Error
}

export abstract class Loadable<T> {
    abstract getState(): LoadingState;

    getValue(): T {
        throw new LoadError(failString("Incorrect loading state."));
    }

    getError(): Failure {
        throw new LoadError(failString("Not an error."));
    }
}

export class Loading<T> extends Loadable<T> {
    private className = "Loading"; // For debugging

    getState = () => {
        return LoadingState.Loading;
    }

    loaded = (value: T) => {
        return new Loaded<T>(value);
    }

    error = (message: string) => {
        return new LoadError<T>(failString(message));
    }

    toString = () => {
        return "Loading()";
    }
}

export class Loaded<T> extends Loadable<T> {
    private className = "Loaded"; // For debugging
    private _value: T;

    constructor(v: T) {
        super();
        this._value = v;
    }

    getState = () => {
        return LoadingState.Loaded;
    }

    getValue = () => {
        return this._value;
    }

    toString = () => {
        return `Loaded ${this.getValue()}`;
    }
}

export class LoadError<T> extends Loadable<T> {
    private className = "LoadError"; // For debugging
    private _error: Failure;

    constructor(error: Failure) {
        super();
        this._error = error;
    }

    getState = () => {
        return LoadingState.Error;
    }

    getError = () => {
        return this._error;
    }

    toString = () => {
        return `Error: ${this.getError()}`;
    }
}